export default (props) => (
  /**
   * Ícone "(>)" com circunferência em volta. Utilizado para
   * realizar requisição do geoserviço.
   * Cor parametrizada.
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.248047"
      y="0.28125"
      width="17"
      height="17"
      rx="8.5"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M6.87737 3.55401C6.93004 3.50704 6.99147 3.47093 7.05813 3.44774C7.12479 3.42455 7.19537 3.41475 7.26582 3.41889C7.33628 3.42304 7.40522 3.44105 7.4687 3.47189C7.53218 3.50273 7.58895 3.5458 7.63576 3.59862L11.935 8.43529C12.0225 8.5336 12.0708 8.6606 12.0708 8.79218C12.0708 8.92377 12.0225 9.05077 11.935 9.14907L7.63576 13.9857C7.53989 14.0876 7.40808 14.1481 7.26834 14.1543C7.1286 14.1605 6.99195 14.112 6.8874 14.0191C6.78286 13.9261 6.32313 13.4006 6.31293 13.2611C6.30273 13.1216 6.34732 12.9836 6.43723 12.8764L10.1133 8.79218L6.42073 4.64217C6.37382 4.58947 6.33776 4.52803 6.31461 4.46138C6.29146 4.39473 6.28167 4.32417 6.28581 4.25373C6.28996 4.18329 6.30795 4.11436 6.33875 4.05088C6.36955 3.9874 6.8246 3.60086 6.87737 3.55401Z"
      fill="white"
    />
  </svg>

);
